enum Sort {
  BEST_MATCH = 'best-match',
  MOST_POPULAR = 'most-popular',
  CLOSEST = 'closest',
  LIST_ORDER = 'list-order',
  DATE = 'date',
  NEWLY_ADDED = 'newly-added',
}

export { Sort };
